/**
 * Which renderer draws the Observers corner plan under the renderer switch
 * (`spec-onboarding-3d-plan-corner-plan-snapshot`, Technical Approach): `PlanSceneProviders` names the
 * picture canvas here, and `ObserverStage` wraps only the corner's `ReadOnlyCanvas` in it. Null with
 * the switch off, so the corner draws with the default renderer.
 *
 * Type-only imports, so reading it loads no map, no scene and nothing of the 3D chunk.
 */
import { createContext } from 'react';
import type { ComponentType } from 'react';
import type { ReadOnlyCanvasProps } from '@repo/ui/planner';

export const PlanPictureRendererContext = createContext<ComponentType<ReadOnlyCanvasProps> | null>(
  null,
);
